module.exports = __webpack_public_path__ + "static/media/kitaseocovid.f8642909.webp";